import { Component, OnInit, Input } from '@angular/core';
import { LabAffiliation } from '../../data/models/lab-affiliation.model';
import { Store, select } from '@ngrx/store';
import { State } from '../../store/state';
import { getActivityId$ } from '../../store/selectors';
import { map, take } from 'rxjs/operators';
import { AppConfig } from '../../../../../app/config/app-config';

@Component({
    selector: 'app-claim-cme-ce-confirmation-message',
    templateUrl: './claim-cme-ce-confirmation-message.component.html',
    styleUrls: ['./claim-cme-ce-confirmation-message.component.css'],
})
export class ClaimCmeCeConfirmationMessageComponent implements OnInit {

    // -----------------------------
    // Inputs
    // -----------------------------
    @Input() kitNumber: string;
    @Input() lab: LabAffiliation;
    @Input() capNumber: string; 

    constructor(private store: Store<State>) {}

    ngOnInit() {}


getLabAffiliationLabel(labAffiliation: LabAffiliation | string | null | undefined): string {

    if (typeof labAffiliation === 'string') {
        return this.capNumber ? `CAP #: ${this.capNumber}` : '';
    }

    const cap = labAffiliation?.capNumber || this.capNumber;

    if (labAffiliation?.orgName) {
        const address = [
            labAffiliation.orgName,
            labAffiliation.address1,
            labAffiliation.city,
            labAffiliation.state,
            labAffiliation.postalCode
        ]
        .filter(value => !!value)
        .join(', ');

        return cap ? `CAP #: ${cap} ${address}` : address;
    }

    if (cap) {
        return `CAP #: ${cap}`;
    }

    return '';
}

    private isNullOrUndefined(param: any): boolean {
        return param === null || param === undefined;
    }


    proceedToClaimCredit() {
        this.store
            .pipe(
                select(getActivityId$),
                take(1),
                map((activityId) => {
                    const w = window.open(
                        `${AppConfig.settings.cecity.inProgressActivity}${activityId}`,
                        '_blank'
                    );

                    if (w) {
                        w.focus();
                    }
                })
            )
            .subscribe();
    }

    backToClaimCmeCe() {
        location.reload();
    }
}
